import * as XLSX from 'xlsx';
import JsPDF from 'jspdf';
import autoTable from "jspdf-autotable";

export const handleExportPDF = (data: any[], allColumns: any[], filename: string) => {
    const columns = allColumns.filter(
        (col) => col.id !== "actions" && col.id !== "select"
    );
    const header = columns.map(col => col.id);
    const compatibleData = data.map(row =>
        columns.map(col => {
            return col.accessorFn ? col.accessorFn(row) : row[col.accessorKey];
        })
    );

    const doc = new JsPDF();
    autoTable(doc, {
        head: [header],
        body: compatibleData,
        margin: {top: 20},
        styles: {
            minCellHeight: 9,
            halign: "left",
            valign: "middle",
            fontSize: 11
        }
    });

    const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fullFilename = `${filename}_${timestamp}.pdf`;
    doc.save(fullFilename);
};

export const handleExportXLSX = (data: any[], allColumns: any[], filename: string) => {
    const columns = allColumns.filter(
        (col) => col.id !== "actions" && col.id !== "select"
    );
    const header = columns.map(col => col.id);
    const compatibleData = data.map(row =>
        columns.map(col => {
            return col.accessorFn ? col.accessorFn(row) : row[col.accessorKey];
        })
    );
    compatibleData.unshift(header); // Add headers as the first row

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(compatibleData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Exported Table Data");

    const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fullFilename = `${filename}_${timestamp}.xlsx`;
    XLSX.writeFile(workbook, fullFilename);
};
